import React from 'react'
import { IconsProps } from 'msp-integrations'

const LeafTimerIcon = (props: IconsProps) => {
  return (
    <svg
      {...props}
      width={props?.width || '78'}
      height={props?.height || '83'}
      viewBox='0 0 21 25'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g fill="none"><path fill="#FFF" d="M-157-923h1680v4264H-157z" /><path d="M10.5 25C4.711 25 0 20.337 0 14.608 0 7.196 9.054 0 10.5 0 11.946 0 21 7.196 21 14.608 21 20.338 16.292 25 10.5 25zM10.494.904C9.462.997.913 7.663.913 14.608c0 5.232 4.3 9.488 9.587 9.488s9.587-4.256 9.587-9.488c0-3.978-2.806-7.867-5.402-10.481L10.5 14.608 10.494.904z" fill="#000" /></g>
    </svg>
  )
}

export default LeafTimerIcon
